import { DocumentStatus } from '../../../../../api/enumerations';

export const getDocumentStatusColor = (status: DocumentStatus): string => {
  if (status === DocumentStatus.APPROVED) return '#00B39B';
  if (status === DocumentStatus.REJECTED) return '#F90B0B';
  return '#FF6600';
};
